export const BADGE_WIDTH_PX = {
    default: 72,
    small: 48,
} as const;

export const BADGE_HEIGHT_RATIO = 0.6;

export const OPEN_ENERGY_LABEL_QUERY_TRIGGER = 'openEnergyLabel';

export const getBadgeTransform = (widthPx: number) => {
    const heightPx = Math.round(widthPx * BADGE_HEIGHT_RATIO);
    return `f_auto,fl_progressive,q_auto,c_fill,g_north,w_${widthPx},h_${heightPx}`;
};

export const getEnergyLabelBadgeAriaLabel = (energyClass: string) =>
    `Öppna energideklaration, energiklass ${energyClass}`;

/** Aria-label for energy-label links that navigate to PDP and open the dialog on load. */
export const getEnergyLabelLinkAriaLabel = (energyClass: string) =>
    `${getEnergyLabelBadgeAriaLabel(energyClass)} (öppnar dialog när sidan laddas)`;

export const getProductUrlWithOpenEnergyLabel = (productUrl: string) => {
    const url = new URL(productUrl, window.location.origin);
    url.searchParams.set(OPEN_ENERGY_LABEL_QUERY_TRIGGER, 'true');
    return `${url.pathname}${url.search}${url.hash}`;
};

/** Removes only `openEnergyLabel` from a location search string; keeps other params. */
export const getSearchWithoutOpenEnergyLabel = (search: string) => {
    const params = new URLSearchParams(search);
    params.delete(OPEN_ENERGY_LABEL_QUERY_TRIGGER);
    const next = params.toString();
    return next ? `?${next}` : '';
};
